import { createFileRoute } from "@tanstack/react-router";
import { SettingsPrivacy } from "@/screens/ParentSettingsSections";
export const Route = createFileRoute("/parent/settings/privacy")({ component: SettingsPrivacy });
